export type Producto = {
  id: number;
  nombre: string;
  descripcion: string;
  precio: string;
  imagen: string;
};

export const productos: Producto[] = [
  {
    id: 1,
    nombre: "Café Espresso",
    descripcion: "Intenso y aromático",
    precio: "15 Bs",
    imagen: "/expreso.jpg",
  },
  {
    id: 2,
    nombre: "Capuccino",
    descripcion: "Con espuma de leche",
    precio: "18 Bs",
    imagen: "/capuchino.jpg",
  },
  {
    id: 3,
    nombre: "Frappe",
    descripcion: "Especiado y reconfortante",
    precio: "17 Bs",
    imagen: "/frappe.jpg",
  },

  {
    id: 3,
    nombre: "Torta tres leches",
    descripcion: "Deliciosa, cremosa.",
    precio: "31 Bs",
    imagen: "/tresLeches.jpg",
  },
];
